import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isNil, sum } from 'lodash'
import i18n from 'simple-react-i18n'
import { Button, Grid } from '@mui/material'
import { StyledFieldSet, StyledLegend } from '../../../../components/StyledElements'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import DisplayedValue from '../../../../components/forms/DisplayedValue'
import DtoPluvioMeasure from '../../../dto/measures/DtoPluvioMeasure'

const EMPTY_TOTALS = ['-', '-', '-']

const computeTotals = (allMeasures, startDate, endDate) => {
    if (isNil(startDate) || isNil(endDate)) {
        return EMPTY_TOTALS
    }
    const { rain = [], ETP: etp = [], efficientRain = [] } = allMeasures
    const sumInRange = arr => sum(
        arr.filter(m => m.date >= startDate && m.date <= endDate).map(m => m.value),
    )
    return [sumInRange(rain), sumInRange(etp), sumInRange(efficientRain)]
}

const PanelEfficientRainCalcul = ({
    allMeasures,
}) => {
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [tmpStart, setTmpStart] = useState()
    const [tmpEnd, setTmpEnd] = useState()

    const [rainTotal, etpTotal, effTotal] = computeTotals(allMeasures, startDate, endDate)

    const onCalculate = () => {
        setStartDate(tmpStart)
        setEndDate(tmpEnd)
    }

    return (
        <StyledFieldSet>
            <StyledLegend>{i18n.effectiveRainCalculation}</StyledLegend>
            <Grid container spacing={2}>
                <Grid size={5}>
                    <SimpleDatePicker
                        id='startDate'
                        label={i18n.startDate}
                        value={tmpStart}
                        onChange={setTmpStart}
                    />
                </Grid>
                <Grid size={5}>
                    <SimpleDatePicker
                        id='endDate'
                        label={i18n.endDate}
                        value={tmpEnd}
                        onChange={setTmpEnd}
                    />
                </Grid>
                <Grid size={2} paddingTop={1}>
                    <Button
                        onClick={onCalculate}
                        variant='contained'
                        disabled={isNil(tmpStart) || isNil(tmpEnd)}
                    >
                        {i18n.calculate}
                    </Button>
                </Grid>
                <Grid size={4}>
                    <DisplayedValue label={i18n.rain} value={rainTotal} />
                </Grid>
                <Grid size={4}>
                    <DisplayedValue label={i18n.etpShort} value={etpTotal} />
                </Grid>
                <Grid size={4}>
                    <DisplayedValue label={i18n.effectiveRain} value={effTotal} />
                </Grid>
            </Grid>
        </StyledFieldSet>
    )
}

PanelEfficientRainCalcul.propTypes = {
    allMeasures: PropTypes.shape({
        rain: PropTypes.arrayOf(PropTypes.instanceOf(DtoPluvioMeasure)),
        ETP: PropTypes.arrayOf(PropTypes.instanceOf(DtoPluvioMeasure)),
        efficientRain: PropTypes.arrayOf(PropTypes.instanceOf(DtoPluvioMeasure)),
    }),
}

export default PanelEfficientRainCalcul
